import CONSTANTS from '../../../Constants'
import ConfirmDialog from '../Dialog/ConfirmDialog'
type UnsavedPopupProps = {
  open: boolean
  onCloseDialog?: () => void
  onConfirm: (() => void) | (() => Promise<void>)
  onClose: () => void
  hideSaveBtn?: boolean
}
const UnsavedPopup = ({
  open,
  onConfirm,
  onCloseDialog,
  onClose,
  hideSaveBtn,
}: UnsavedPopupProps) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      onCloseDialog={onCloseDialog}
      title='Unsaved Changes'
      description={CONSTANTS.UNSAVED_CHANGES_DESCRIPTION}
      btn2Label={hideSaveBtn ? '' : 'Save Changes'}
      btn1Label='Discard Changes'
      btn2Color='warning'
      icon='DeleteRoleWarIcon'
      testID1='DiscardChangesBtn'
      testID2='SaveChangesBtn'
    />
  )
}

export default UnsavedPopup
